var map = {
	"./amorim.png": "fb5a",
	"./bois.jpg": "24fa",
	"./cuscuzeria.png": "3498",
	"./kabanas.jpg": "40b8",
	"./pitstop.png": "3be0",
	"./prime-burguer.png": "57d7",
	"./punch.png": "f306"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ddb";